import { apiClient } from '~/services/api-service';
import { ByParamsResponse, StatsFullResponse, StatsParams, StatsResponse } from '~/types/stats';
import { createQueryString } from '~/utils/createQueryString';

export const statsAPIService = {
  getStatsQrCode: (params: Partial<StatsParams>) => {
    const queryString = createQueryString(params);
    return apiClient.get<StatsFullResponse>(`/stats/full/?${queryString}`, {
      params,
    });
  },
  // getStatsQrCodes: (params: Partial<StatsParams>) => {
  //   const queryString = createQueryString(params);
  //   return apiClient.get<StatsResponse>(`/stats/full/?${queryString}`);
  // },
  getStatsQrCodes: (params: Partial<StatsParams>) => {
    return apiClient.get<StatsResponse>(`/stats/full/`, { params });
  },

  getStatsQrByPramsFull: (params: Partial<StatsParams>) => {
    return apiClient.get<ByParamsResponse>(`/stats/full/by_params_full/`, {
      params,
    });
  },
};
